<template>
  <div>
    <Loader ref="Loader"></Loader>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense color="secondary" dark>
          <v-toolbar-title>Ops Manager Task Report</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- FILTER -->
        <v-flex xs12 sm12 lg12>
          <v-card elevation-5 dark>
            <v-card-title class="title">Filters</v-card-title>
            <v-layout ma-2>
              <!-- <v-flex lg3 xs3 sm3 mr-2>
                <v-combobox label="Select customer" v-model="selectedCustomer" :items="customerItems" item-text="Name"
                  item-value="ID" @change="FetchVenues()"></v-combobox>
              </v-flex> -->
              <v-flex lg6 xs6 sm6 mr-2>
                <v-combobox label="Select venue" v-model="selectedVenue" :items="venueItems" item-text="Name"
                  item-value="ID"></v-combobox>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="startDateFormatted" label="Start Date" hint="MM/DD/YYYY format"
                      persistent-hint prepend-icon="event" @blur="startDate = parseStartDate(startDateFormatted)"
                      v-on="on">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title @input="menu1 = false">
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu ref="menu1" v-model="menu2" :close-on-content-click="false" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="endDateFormatted" label="End Date" hint="MM/DD/YYYY format" persistent-hint
                      prepend-icon="event" @blur="endDate = parseEndDate(endDateFormatted)" v-on="on">
                    </v-text-field>
                  </template>
                  <!-- <v-date-picker v-model="endDate" no-title @input=""> -->
                  <v-date-picker v-model="endDate" no-title @input="menu2 = false">
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout justify-end ma-2 row>
              <v-btn flat outline @click="filterItems()">Filter</v-btn>
              <v-btn flat outline @click="clearFilter()">Clear Filter</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
        <v-layout ma-2>
          <v-flex xs3>
            <h3>Ops Manager Tasks</h3>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-2>
          <!-- Widgets-->
          <v-flex d-flex lg3 sm6 xs12>
            <widget icon="domain" :count="OpsSuccessfulVisits" supTitle="Successful customer visits" color="#00b297" />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget icon="domain" :count="OpsUnsuccessfulVisits" supTitle="Unsuccessful customer visits"
              color="#dc3545" />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget icon="group_work" :count="OpsManagerTasksComplete" supTitle="Inspections completed"
              color="#0866C6" />
          </v-flex>
          <v-flex d-flex lg3 sm6 xs12>
            <widget icon="watch_later" :title="OpsManagerEfficiency"
              supTitle="Ops manager efficiency of tasks complete vs tasks incomplete" color="#1D2939" />
          </v-flex>
        </v-layout>
        <v-container>
          <v-layout mr-2>
            <v-flex xs4>
              <v-combobox v-model="selectedOpsmanager" label="Select ops-manager" :items="opsManagerList"
                item-text="FullName" item-value="ID" @change="CheckSelectedOpsManager()"
                :disabled="opsManagerList.length == 0">
              </v-combobox>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs4>
              <v-text-field append-icon="search" v-model="search" placeholder="Search ops-manager tasks">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-flex d-flex lg12 sm12 xs12>
            <v-data-table class="table" :headers="opsManagerItemHeaders" :items="opsManagerItems"
              :rows-per-page-items="[50, 75, 100]" :search="search">
              <template v-slot:items="props">
                <td>{{ props.index+1 }}</td>
                <td class="text-xs-left">{{ props.item.DateTime }}</td>
                <td class="text-xs-left">{{ props.item.OpsManager }}</td>
                <td class="text-xs-left">{{ props.item.Type }}</td>
                <td class="text-xs-left">{{ props.item.Inspection }}</td>
                <td class="text-xs-left">{{ props.item.Complete }}</td>
                <td class="text-xs-left">{{ props.item.CustomerComments }}</td>
                <td class="text-xs-left">{{ props.item.OpsComments }}</td>
                <td class="text-xs-left">{{ props.item.CustomerRating }}</td>
                <td class="text-xs-left">{{ props.item.OpsRating }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-container>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
  import Widget from './Widget.vue';
  import DataTable from './DataTable.vue';
  import TimeLine from './TimeLine.vue';
  import LocationStatistic from './LocationStatistic.vue';
  import SiteViewStatistic from './SiteViewStatistic.vue';
  import TotalEarningsStatistic from './TotalEarningsStatistic.vue';
  import moment from 'moment';
  import JWT from "jsonwebtoken";

  export default {
    data() {
      return {
        tmp: [],
        selectedOpsmanager: null,
        opsManagerList: [],
        role: null,
        userID: 0,
        startDate: null,
        endDate: null,
        startDateFormatted: this.formatStartDate(new Date().toISOString().substr(0, 10)),
        endDateFormatted: this.formatEndDate(new Date().toISOString().substr(0, 10)),
        menu1: false,
        menu2: false,
        CheckInsForToday: 0,
        today: moment(Date.now()).format("YYYY-MM-DD"),
        customerItems: [],
        selectedCustomer: null,
        venueItems: [],
        selectedVenue: null,
        NumberOfCompletedSupervisorTasksForToday: null,
        SupervisorInspectionsCompletedToday: 0,
        NumberOfCompletedOpsTasksForToday: null,
        OpsInspectionsCompletedToday: 0,
        CompleteIncomplete: {
          Complete: 0,
          Incomplete: 0,
          Total: 0,
          Efficiency: ""
        },
        superVisorItems: [],
        opsManagerItems: [],
        superVisorHeaders: [{

          },
          {
            value: 'Date',
            text: "Date",
            align: 'left',
            sortable: true
          },
          {
            text: 'Supervisor',
            value: 'Supervisor',
            align: 'left',
            sortable: true
          },
          {
            text: 'Completed',
            value: 'Completed',
            align: 'left',
            sortable: true
          },
          {
            text: 'Comments',
            value: 'Comments',
            align: 'left',
            sortable: true
          },
          {
            text: 'FilePath',
            value: 'FilePath',
            align: 'left',
            sortable: true
          },
        ],
        opsManagerItemHeaders: [{

          },
          {
            value: 'DateTime',
            text: "Date",
            align: 'left',
            sortable: true
          },
          {
            text: 'Ops Manager',
            value: 'OpsManager',
            align: 'left',
            sortable: true
          },
          {
            text: 'Type',
            value: 'Type',
            align: 'left',
            sortable: true
          },
          {
            text: 'Inspection',
            value: 'Inspection',
            align: 'left',
            sortable: true
          },
          {
            text: 'Complete',
            value: 'Complete',
            align: 'left',
            sortable: true
          },
          {
            text: 'Customer Comments',
            value: 'CustomerComments',
            align: 'left',
            sortable: true
          },
          {
            text: 'Ops Manager Comments',
            value: 'OpsComments',
            align: 'left',
            sortable: true
          },
          {
            text: 'Customer Rating',
            value: 'CustomerRating',
            align: 'left',
            sortable: true
          },
          {
            text: 'Ops Manager Rating',
            value: 'OpsRating',
            align: 'left',
            sortable: true
          },
        ],
        search: null,
        OpsManagerTasksComplete: 0,
        OpsManagerTasksIncomplete: 0,
        OpsManagerEfficiency: null,
        OpsSuccessfulVisits: 0,
        OpsUnsuccessfulVisits: 0,
      }
    },
    components: {
      Widget,
      DataTable,
      TimeLine,
      LocationStatistic,
      SiteViewStatistic,
      TotalEarningsStatistic
    },
    computed: {
      computedDateFormatted() {
        return this.formatStartDate(this.startDate)
        return this.formatEndDate(this.endDate)
      }
    },
    watch: {
      startDate(val) {
        this.startDateFormatted = this.formatStartDate(this.startDate)
      },
      endDate(value) {
        this.endDateFormatted = this.formatEndDate(this.endDate)
      },
    },
    mounted() {
      let self = this;
      let tokenDecoded = JWT.decode(localStorage.accessToken);
      console.log("[TOKEN DECODED]", tokenDecoded)

      self.userID = localStorage.getItem("USER_ID");
      console.log("USER_ID", self.userID)
      self.role = localStorage.getItem("Role");
      console.log("ROLE", self.role)

      var date = new Date();
      self.startDate = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().substr(0, 10);
      self.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().substr(0, 10);

      self.FetchVenues();
      self.FetchOpsManagers();
      //self.FetchCustomers(self.role, self.userID);

      //self.getCheckIns(role, userID);
      //self.getSupervisorTotalTasksCompletedForToday(self.role, self.userID);
      //self.getOpsManagerTasksCompletedForToday(self.role, self.userID);
    },
    methods: {
      FetchCustomers(role, userID) {
        let self = this;

        let url;

        switch (role.toLowerCase()) {
          case "Master": {
            url = `Customer`;
          }
          break;
        case "Admin": {
          url = `Customer`;
        }
        break;
        default: {
          url = `Customer/GetBySystemUser?systemUserID=${self.userID}`;
        }
        break;
        }

        self.get(url)
          .then(response => {
            self.customerItems = response.data;
            console.log("[CUSTOMER ITEMS]", self.customerItems);
          })
          .catch(error => {
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });
      },
      FetchVenues() {
        let self = this;

        self.$nextTick(() => {
          self.get(`CustomerVenue/CustomerID?customerID=${self.userID}`).then(r => {
            console.log("[VENUE ITEMS FOR CUSTOMER]", r.data)
            self.venueItems = r.data;
          })
        })
      },
      FetchOpsManagers() {
        let self = this;

        self.get(`SystemUser/GetOpsManagers/CustomerID?customerID=${self.userID}`).then(r => {
          console.log("[OPS-MANAGER LIST]", r.data)
          self.opsManagerList = r.data;
        })
      },
      CheckSelectedOpsManager() {
        let self = this;
        self.OpsManagerTasksComplete = 0;
        self.OpsManagerTasksIncomplete = 0;
        self.OpsSuccessfulVisits = 0;
        self.OpsUnsuccessfulVisits = 0;

        self.opsManagerItems = [];
        self.$nextTick(() => {
          console.log("[selected ops manager]", self.selectedOpsmanager.ID)


          self.get(
            `SQLReporting/OpsManagerTasks/ByOps?systemUserID=${self.selectedOpsmanager.ID}&venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
          ).then(r => {
            console.log("[TASKS FOR SELECTED SUPERVISOR]", r.data)

            r.data.forEach(item => {
              // if (item.OpsManager == self.selectedOpsmanager.FullName) {
              self.opsManagerItems.push(item);

              if (item.Complete == true && item.Type == 2) {
                self.OpsManagerTasksComplete = self.OpsManagerTasksComplete + 1;
              } else if (item.Complete == false && item.Type == 2) {
                self.OpsManagerTasksIncomplete = self.OpsManagerTasksIncomplete + 1;
              }

              if (item.Type == 'Customer Visit' && item.Complete == true) {
                self.OpsSuccessfulVisits = self.OpsSuccessfulVisits + 1;
              } else if (item.Type == 'Customer Visit' && item.Complete == false) {
                self.OpsUnsuccessfulVisits = self.OpsUnsuccessfulVisits + 1;
              }
            })

            self.OpsManagerEfficiency = parseFloat((self.OpsManagerTasksComplete / (self
              .OpsManagerTasksComplete +
              self.OpsManagerTasksIncomplete)) * 100).toFixed(2) + "%";

            console.log("[NUMBER OF OPSMANAGER TASKS COMPLETED]", self.OpsManagerTasksComplete)
            console.log("[NUMBER OF OPSMANAGER TASKS INCOMPLETE]", self.OpsManagerTasksIncomplete)
            console.log("[OPSMANAGER EFFICIENCY]", self.OpsManagerEfficiency)
          })

        })
      },
      filterItems() {
        let self = this;
        if (self.selectedVenue.ID != null) {
          self.$refs.Loader.show(true);
          self.$refs.Loader.setText("Filtering items...");
          console.log("SELECTED DATES", self.startDate, self.endDate);
          self.menu2 = false;
          self.getCheckIns();
          self.getSupervisorTotalTasks();
          self.getOpsTotalTasks();
          self.getCompleteVsIncomplete();
          self.getSupervisorTasks();
          self.getOpsManagerTasks();
          self.$refs.Loader.hide();
        }
      },
      clearFilter() {
        let self = this;
        self.selectedCustomer = null;
        self.selectedVenue = null;
        self.opsManagerItems = [];
        self.superVisorItems = [];
        self.CheckInsForToday = 0;
        self.SupervisorInspectionsCompletedToday = 0;
        self.OpsInspectionsCompletedToday = 0;
        self.CompleteIncomplete.Efficiency = "";
        self.selectedOpsmanager = null;
        self.opsManagerList = []
      },
      getCheckIns() {
        let self = this;

        // TODO GET FOR OTHER ROLES/USER
        if (self.role == "Master" || self.role == "Admin") {
          self.get(
            `SQLReporting/TotalCheckInsByVenue?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
          ).then(r => {
            console.log("wtf is this", r)
            self.CheckInsForToday = r.data.length;
          })
        }

      },
      getSupervisorTotalTasks() {
        let self = this;

        var inspectionCompletedCount = 0;
        self.SupervisorInspectionsCompletedToday = 0;
        // TODO GET FOR OTHER ROLES/USER
        if (self.role == "Master" || self.role == "Admin") {
          self.get(
            `SQLReporting/TotalSupervisorTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
          ).then(r => {
            console.log("[SUPERVISOR TASKS]", r.data)
            r.data.forEach(el => {
              inspectionCompletedCount = inspectionCompletedCount + el.TotalJobsComplete;
            })
            self.SupervisorInspectionsCompletedToday = inspectionCompletedCount;
            console.log("SUPERVISOR TASKS COMPLETED", self.SupervisorInspectionsCompletedToday)
          })
        }
      },
      getOpsTotalTasks() {
        let self = this;

        self.get(
          `SQLReporting/TotalOpsInspectionTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        ).then(r => {
          console.log("OPS MANAGER TOTAL", r);
          self.OpsInspectionsCompletedToday = r.data[0].TotalCustomerVisits;
        })
      },
      getCompleteVsIncomplete() {
        let self = this;

        self.get(
          `SQLReporting/SupervisorCompleteVsInComplete?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        ).then(r => {
          console.log("[COMPLETE VS INCOMPLETE]", r)

          self.CompleteIncomplete.Complete = r.data[0].TotalComplete;
          self.CompleteIncomplete.Incomplete = r.data[0].TotalIncomplete
          self.$nextTick(() => {
            self.CompleteIncomplete.Total = self.CompleteIncomplete.Complete + self.CompleteIncomplete
              .Incomplete

            if (self.CompleteIncomplete.Total > 0) {
              self.CompleteIncomplete.Efficiency = parseFloat((self.CompleteIncomplete.Complete / self
                .CompleteIncomplete.Total) * 100).toFixed(2) + "%";
            }
          })

          console.log("COMPLETE/INCOMPLETE", self.CompleteIncomplete)
        })
      },
      getSupervisorTasks() {
        let self = this;

        self.get(
          `SQLReporting/SupervisorTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        ).then(r => {
          console.log("[SUPERVISOR TASKS FOR TABLE]", r.data)
          self.superVisorItems = r.data;

          self.superVisorItems.forEach(task => {
            task.Date = moment(task.Date).format(
              "YYYY-MM-DD hh:mm:ss");
          })
        })
      },
      getOpsManagerTasks() {
        let self = this;
        self.OpsManagerTasksComplete = 0;
        self.OpsManagerTasksIncomplete = 0;
        self.OpsSuccessfulVisits = 0;
        self.OpsUnsuccessfulVisits = 0

        self.get(
          `SQLReporting/OpsManagerTasks?venueID=${self.selectedVenue.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        ).then(r => {
          console.log("[OPS-MANAGER] TASKS FOR TABLE", r.data)
          self.opsManagerItems = r.data;
          self.tmp = r.data;
          self.opsManagerItems.forEach(task => {
            task.DateTime = moment(task.DateTime).format(
              "YYYY-MM-DD");

            task.OpsRating = task.OpsRating + "/5"

            if (task.Inspection == null) {
              task.Inspection = "N/A"
            }

            if (task.Complete == true && task.Type == 2) {
              self.OpsManagerTasksComplete = self.OpsManagerTasksComplete + 1;
            } else if (task.Complete == false && task.Type == 2) {
              self.OpsManagerTasksIncomplete = self.OpsManagerTasksIncomplete + 1;
            }

            if (task.Type == 1) {
              task.Type = "Customer Visit";
              task.OpsRating = "N/A";

            } else if (task.Type == 2) {
              task.Type = "Inspection"
            }

            if (task.CustomerComments == null) {
              task.CustomerComments = "N/A"
            }

            if (task.OpsComments == null) {
              task.OpsComments = "N/A"
            }

            if (task.CustomerRating == 1) {
              task.CustomerRating = "Good"
            } else if (task.CustomerRating == 0) {
              task.CustomerRating = "Bad"
            }

            if (task.CustomerRating == "Bad" && task.Type == "Inspection") {
              task.CustomerRating = "N/A"
            }

            if (task.OpsRating == null) {
              task.OpsRating = 0;
            }

            if (task.Type == 'Customer Visit' && task.Complete == true) {
              self.OpsSuccessfulVisits = self.OpsSuccessfulVisits + 1;
            } else if (task.Type == 'Customer Visit' && task.Complete == false) {
              self.OpsUnsuccessfulVisits = self.OpsUnsuccessfulVisits + 1;
            }
          })
          self.OpsManagerEfficiency = parseFloat((self.OpsManagerTasksComplete / (self
            .OpsManagerTasksComplete +
            self.OpsManagerTasksIncomplete)) * 100).toFixed(2) + "%";

          console.log("[NUMBER OF OPSMANAGER TASKS COMPLETED]", self.OpsManagerTasksComplete)
          console.log("[NUMBER OF OPSMANAGER TASKS INCOMPLETE]", self.OpsManagerTasksIncomplete)
          console.log("[OPSMANAGER EFFICIENCY]", self.OpsManagerEfficiency)
        })
      },
      // getSupervisorTotalTasksCompletedForToday(role, userID) {
      //   let self = this;

      //   var inspectionCompletedCount = 0;
      //   self.SupervisorInspectionsCompletedToday = []

      //   // TODO GET FOR OTHER ROLES/USER
      //   if (self.role == "Master" || self.role == "Admin") {
      //     self.get(`SupervisorInspectionTX/GetAllComplex`).then(r => {
      //       r.data.forEach(task => {
      //         task.SupervisorInspectionTx.forEach(tx => {
      //           tx.Date = moment(tx.Date).format(
      //             "YYYY-MM-DD");

      //           // get completed tasks for today
      //           self.$nextTick(() => {
      //             if (tx.Date == self.today) {
      //               self.SupervisorInspectionsCompletedToday.push(tx);
      //               self.NumberOfCompletedSupervisorTasksForToday = self
      //                 .SupervisorInspectionsCompletedToday.length;
      //             }
      //             console.log("[COMPLETED DASHBOARD SUPERVISOR TASKS]", self
      //               .NumberOfCompletedSupervisorTasksForToday)
      //           })
      //         })
      //       })
      //     })
      //   }
      // },
      // getOpsManagerTasksCompletedForToday(role, userID) {
      //   let self = this;
      //   self.OpsInspectionsCompletedToday = [];

      //   self.get(`OpsManagerTX/GetAll`).then(r => {
      //     r.data.forEach(inspection => {
      //       inspection.DateTime = moment(inspection.DateTime).format(
      //         "YYYY-MM-DD");

      //       if (inspection.DateTime == self.today) {
      //         self.OpsInspectionsCompletedToday.push(inspection);
      //       }
      //     })
      //     console.log("[OPS-MANAGER-INSPECTIONS COMPLETED TODAY]", self.OpsInspectionsCompletedToday)
      //   })
      // },
      // DATE FILTERING
      parseDate(date) {
        let self = this;
        console.log("PARSED DATE", date);
      },
      filterByDate() {
        let self = this;
        var labels = [];
        var data = [];

        console.log("[FILTER START DATE]", self.startDate);
        console.log("[FILTER END DATE]", self.endDate);


      },
      formatStartDate(startDate) {
        if (!startDate) return null

        const [year, month, day] = startDate.split('-')
        return `${month}/${day}/${year}`
      },
      formatEndDate(endDate) {
        if (!endDate) return null

        const [year, month, day] = endDate.split('-')
        return `${month}/${day}/${year}`
      },
      parseStartDate(startDate) {
        if (!startDate) return null

        const [month, day, year] = startDate.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      parseEndDate(endDate) {
        if (!endDate) return null

        const [month, day, year] = endDate.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    }
  }
</script>

<style>

</style>